//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name:'operationBoardDetail',
  data(){
    return {period:'today',dimension:'all',startDate:'',endDate:'',page:0,limit:15,loading:false,busy:false,hasNext:true,errorText:'',list:[],data:{}}
  },
  computed:{
    periodLabel(){ return this.period === 'custom' && this.startDate && this.endDate ? this.startDate+' 至 '+this.endDate : ({today:'今日',yesterday:'昨日',week:'本周',month:'本月',year:'本年'}[this.period] || '今日'); }
  },
  created(){
    var periods=['today','yesterday','week','month','year','custom'];
    var dimensions=['all','laundry','housework','card','stored','discount','package','year','times','mini','offline','douyin'];
    var p=String(this.$route.query.period || 'today');
    var d=String(this.$route.query.dimension || 'all');
    this.period=periods.indexOf(p) >= 0 ? p : 'today';
    this.startDate=String(this.$route.query.start_date || '');
    this.endDate=String(this.$route.query.end_date || '');
    if(this.period === 'custom' && (!this.startDate || !this.endDate)) this.period='today';
    this.dimension=dimensions.indexOf(d) >= 0 ? d : 'all';
    this.loadMore();
  },
  methods:{
    reload(){ this.page=0;this.list=[];this.hasNext=true;this.errorText='';this.loadMore(); },
    loadMore(){
      if(this.busy || !this.hasNext) return;
      this.busy=true;this.loading=true;this.errorText='';
      var nextPage=this.page+1;
      var params={period:this.period,dimension:this.dimension,page:nextPage,limit:this.limit};
      if(this.period === 'custom'){
        params.start_date=this.startDate;
        params.end_date=this.endDate;
      }
      this.$api.operationBoardDetail(params).then((res)=>{
        this.busy=false;this.loading=false;
        if(!(res && res.data)){
          if(!this.list.length) this.errorText='明细加载失败';
          return;
        }
        this.data=res.data;
        this.page=nextPage;
        this.list=this.list.concat(Array.isArray(res.data.list) ? res.data.list : []);
        this.hasNext=Number(res.data.hasNext) > 0;
      }).catch(()=>{
        this.busy=false;this.loading=false;
        if(!this.list.length) this.errorText='明细加载失败，请稍后重试';
      });
    },
    backToBoard(){
      var query={period:this.period};
      if(this.period === 'custom'){
        query.start_date=this.startDate;
        query.end_date=this.endDate;
      }
      this.$router.push({name:'operationBoard',query:query});
    },
    money(value){ return (Number(value)||0).toLocaleString('zh-CN',{minimumFractionDigits:2,maximumFractionDigits:2}); },
    count(value){ return (Number(value)||0).toLocaleString('zh-CN'); }
  }
}



// WEBPACK FOOTER //
// ./src/pages/operationBoardDetail.vue